export const HMMRepeatedValues = {
  treatment: '',
  exercises: [],
  status: '',
  currentStatusDuringTreatment: '',
  subjectiveNotes: '',
  PatientInstructionsAndRecommendations: '',
};
